// extracted by mini-css-extract-plugin
export default {"modalOverlay":"modal_modalOverlay__SzSjN","modalContent":"modal_modalContent__it7xC","closeButton":"modal_closeButton__oou6M"};